import { Box, Button, HStack, VStack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { ROUTES } from '../../../config';
import { useDashboardModel } from '../../models/DashboardModel';
import { DashboardTable } from './DashboardTable';
import { MobileTable } from './MobileTable';

export const Investments: React.FC = () => {
  const model = useDashboardModel();

  return (
    <Box w={'100%'}>
      <TextBlock weight="bold" fontSize={32}>
        Investments
      </TextBlock>

      {(model.investments && model.investments.length > 0) || false ? (
        <>
          <Box display={['none', 'none', 'flex', 'flex']}>
            <DashboardTable data={model.investments} />
          </Box>
          <Box display={['flex', 'flex', 'none', 'none']}>
            <MobileTable data={model.investments} />
          </Box>
        </>
      ) : (
        <Box display="flex" flex={1} alignItems="center" justifyContent="center">
          <VStack w="100%" gap="24px">
            <Image w="75px" h="60px" image="faded-business" />
            <TextBlock weight="bold" textAlign="center" verticalAlign="center">
              You do not have any investments.
            </TextBlock>
            <HStack gap="10px">
              <Button as={Link} to={ROUTES.offeringsCashflow}>
                Invest in Cashflow
              </Button>
              <Button as={Link} to={ROUTES.properties}>
                Invest in a Property
              </Button>
            </HStack>
          </VStack>
        </Box>
      )}
    </Box>
  );
};
